(function () {
  var STORAGE_KEY = 'vm_ship_timer_start_v1';

  function berlinNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function addCalendarDays(d, n) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
    x.setDate(x.getDate() + n);
    return x;
  }
  function fmtHMS(ms) {
    ms = Math.max(0, ms);
    var hrs = Math.floor(ms / 3600000);
    var mins = Math.floor((ms % 3600000) / 60000);
    var secs = Math.floor((ms % 60000) / 1000);
    return pad(hrs) + ':' + pad(mins) + ':' + pad(secs);
  }
  function shipdayLabel(now, pastCutoff, weekdayLabel, weekendLabel) {
    // Order day (advance if past cutoff)
    var order = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (pastCutoff) order.setDate(order.getDate() + 1);
    var od = order.getDay(); // 0=Sun .. 6=Sat
    if (od === 0 || od === 5 || od === 6) return weekendLabel || 'Montag';
    return weekdayLabel || 'nächsten Werktag';
  }
  function nextDailyCutoff(now, h, m) {
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, 0, 0);
    var past = now >= cutoff;
    if (past) cutoff = addCalendarDays(cutoff, 1);
    return { cutoff: cutoff, past: past };
  }
  function durationEnd(root, durationH, autoRestart) {
    var ms = Math.max(1, durationH) * 3600000;
    var key = STORAGE_KEY + '_' + (root.id || root.getAttribute('data-block-id') || 'default');
    var start = null;
    try { start = parseInt(localStorage.getItem(key) || '', 10); } catch (e) {}
    var nowMs = Date.now();
    if (!start || isNaN(start) || start > nowMs) {
      start = nowMs;
      try { localStorage.setItem(key, String(start)); } catch (e) {}
    }
    var end = start + ms;
    if (nowMs >= end) {
      if (autoRestart) {
        start = nowMs;
        end = start + ms;
        try { localStorage.setItem(key, String(start)); } catch (e) {}
      } else {
        return { end: end, expired: true };
      }
    }
    return { end: end, expired: false };
  }
  function parseFixedEnd(raw) {
    if (!raw) return null;
    // Accept ISO or "YYYY-MM-DD HH:MM" Berlin-ish
    var s = String(raw).trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(s)) s += ':00';
    var d = new Date(s);
    if (isNaN(d.getTime())) return null;
    return d;
  }
  function render(root) {
    var mode = root.getAttribute('data-mode') || 'daily_cutoff';
    var tpl = root.getAttribute('data-timer-tpl') || 'Bestelle innerhalb [time] – Versand am [shipday]';
    var weekdayLabel = root.getAttribute('data-weekday-label') || 'nächsten Werktag';
    var weekendLabel = root.getAttribute('data-weekend-label') || 'Montag';
    var now = berlinNow();
    var timeStr = '00:00:00';
    var shipLabel = weekdayLabel;
    var past = false;

    if (mode === 'fixed') {
      var end = parseFixedEnd(root.getAttribute('data-fixed-end'));
      if (!end) {
        // fallback to daily
        mode = 'daily_cutoff';
      } else {
        timeStr = fmtHMS(end - Date.now());
        past = Date.now() >= end.getTime();
        shipLabel = shipdayLabel(now, false, weekdayLabel, weekendLabel);
      }
    }
    if (mode === 'duration') {
      var durH = parseFloat(root.getAttribute('data-duration-h') || '24') || 24;
      var auto = root.getAttribute('data-auto-restart') !== '0';
      var d = durationEnd(root, durH, auto);
      timeStr = fmtHMS(d.end - Date.now());
      shipLabel = shipdayLabel(now, false, weekdayLabel, weekendLabel);
    }
    if (mode === 'daily_cutoff') {
      var h = parseInt(root.getAttribute('data-cutoff-h') || '23', 10);
      var m = parseInt(root.getAttribute('data-cutoff-m') || '59', 10);
      var c = nextDailyCutoff(now, h, m);
      timeStr = fmtHMS(c.cutoff - now);
      past = c.past;
      shipLabel = shipdayLabel(now, past, weekdayLabel, weekendLabel);
    }

    var text = tpl
      .replace(/\[time\]|\{\{\s*time\s*\}\}/g, '<strong class="vm-ship-timer__clock" data-vm-ship-timer-time>' + timeStr + '</strong>')
      .replace(/\[shipday\]|\{\{\s*shipday\s*\}\}/g, '<strong data-vm-ship-timer-day>' + shipLabel + '</strong>');

    var el = root.querySelector('[data-vm-ship-timer-text]');
    if (el) el.innerHTML = text;
  }
  function boot() {
    document.querySelectorAll('[data-vm-ship-timer]').forEach(function (el) {
      render(el);
      if (!el._vmShipTimer) {
        el._vmShipTimer = setInterval(function () { render(el); }, 1000);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
